import { CloseOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';

import {
  dismissScan,
  selectAllScans,
  ScanState,
} from '@/state/slices/copilot/copilotScans.ts';

import styles from './ScanProgressStrip.module.css';

export function ScanProgressStrip() {
  const scans = useSelector(selectAllScans);
  const dispatch = useDispatch();

  if (scans.length === 0) return null;

  return (
    <div className={styles.wrap}>
      {scans.map((s) => (
        <ScanRow
          key={s.scanId}
          scan={s}
          onDismiss={() => dispatch(dismissScan({ scanId: s.scanId }))}
        />
      ))}
    </div>
  );
}

function ScanRow({
  scan,
  onDismiss,
}: {
  scan: ScanState;
  onDismiss: () => void;
}) {
  const SUFFIXES: Record<ScanState['status'], string> = {
    running: '',
    complete: ' ✓',
    failed: ' ✗',
  };
  const label = `${scan.product}${SUFFIXES[scan.status]}`;

  return (
    <div className={styles.row}>
      <span className={styles.product}>{label}</span>
      <div className={styles.bar}>
        <div className={styles.fill} style={{ width: `${scan.progress}%` }} />
      </div>
      <span className={styles.pct}>{scan.progress}%</span>
      {scan.status !== 'running' && (
        <button
          type="button"
          className={styles.dismiss}
          onClick={onDismiss}
          aria-label="Dismiss"
        >
          <CloseOutlined />
        </button>
      )}
    </div>
  );
}
